import {React, useState, useEffect} from "react";
import '../../../../../css/home.css';
import { useTranslation } from "react-i18next";
import enQRImage from "../../../../../assets/images/EN_QR.jpg";
import nlQRImage from "../../../../../assets/images/NL_QR.jpg";
import frQRImage from "../../../../../assets/images/FR_QR.jpg";
import grQRImage from "../../../../../assets/images/GR_QR.jpg";
import itQRImage from "../../../../../assets/images/IT_QR.jpg";
import enInfoImage from "../../../../../assets/images/mobile_app_info_en.png";
import nlInfoImage from "../../../../../assets/images/mobile_app_info_nl.png";
import frInfoImage from "../../../../../assets/images/mobile_app_info_fr.png";
import grInfoImage from "../../../../../assets/images/mobile_app_info_gr.png";
import itInfoImage from "../../../../../assets/images/mobile_app_info_it.png";
import playstore from "../../../../../assets/images/Playstore.svg";
import appstore from "../../../../../assets/images/Apple.svg";

function DownloadApp() {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleSize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    handleSize();
    // Add listener
    window.addEventListener("resize", handleSize);

    // Cleanup
    return () => window.removeEventListener("resize", handleSize);
  });
  const language = i18n.language;
  //desktop-image
    const imageSrc = {
      en: enQRImage,
      nl: nlQRImage,
      fr: frQRImage,
      gr: grQRImage,
      it: itQRImage,
    }[language] || enInfoImage;
    //mobile-image
    const infoSrc = {
      en: enInfoImage,
      nl: nlInfoImage,
      fr: frInfoImage,
      gr: grInfoImage,
      it: itInfoImage,
    }[language] || enInfoImage;
  return (
    isMobile ? (
      <div className="download-qr-fold-mobile">
        <div className="sub-fold text-center">
          <div className="left">
            <h2 className="text-white">{t('Download the app now')}</h2>
            <p className="text-white m-auto">{t('Stay connected with your mosque prayers, events, announcements, and easy online donations.')}</p>
          </div>
          <div className="d-flex store-block-container align-items-center justify-content-around">
            <div className="store-block bg-black">
              <a href="https://play.google.com/store/apps/details?id=com.testmosqueappnew&pcampaignid=web_share" target="_blank" rel="noreferrer">
                <div className="store">
                  <img src={playstore} alt="playstore-icon" width={26} height={30}  className="mr-3"/>
                  <div className="">
                    <h5 className="">{t('GET IT ON')}</h5>
                    <p className="google m-0">{t("Google Play")}</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="store-block bg-black">
              <a href="https://apps.apple.com/in/app/mosqapp/id6478959190" target="_blank" rel="noreferrer">
                <div className="store overflow-hidden">
                  <img src={appstore} alt="playstore-icon" width={26} height={30} className="left"/>
                  <div className="right">
                    <h6 className="">{t('Download on the')}</h6>
                    <p className="m-0">{t('App Store')}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="right">
            <img src={infoSrc} alt="QR-Code" width={"auto"} height={"auto"}/>
          </div>
        </div>
      </div>
    ) : (
      <div className="download-qr-fold pb-0">
      <div className="sub-fold">
        <div className="d-flex inner">
          <div className="left">
            <h2>{t('Download the app now')}</h2>
            <p>{t('Stay connected with your mosque prayers, events, announcements, and easy online donations.')}</p>
          </div>
          <div className="right">
            <img src={imageSrc} alt="QR-Code" />
          </div>
        </div>
      </div>
    </div>
    )
  )
}

export default DownloadApp;